import { useEffect, useState } from "react";
import { makeTagEnumFriendly } from "../../enum";
import FilterableForm from "../common/filterableForm";
import useApi from "../../api";
import { toast } from "react-toastify";

interface OrderFilterProps {
  isOpen: boolean;
  onClose: () => void;
}

function StockFilter({ isOpen, onClose }: OrderFilterProps) {  
  const [warehouses, setWarehouses] = useState<any>()
  const api = useApi()

  useEffect(()=>{
    if(isOpen){
      api.getWarehouses().then((response:any)=>{
        setWarehouses(response.results)
      }).catch(()=>toast.error('Error fetch warehouse.'))
    }
  }, [isOpen])

  return (
    
    <FilterableForm
      title="Stock Filters"
      fields={[
          { name: "warehouse", label: "warehouse", type: "select", options: makeTagEnumFriendly(warehouses || []), defaultValue: "" },

      ]}
      onClose={onClose}
    />

  );
}

export default StockFilter;